<div class="relative">
  <div class="mdw-tiptap-chip-list-input scrollable" [class.focus]="isFocussed()">
    <div #tiptapEditorEl class="tiptap-chip-editor" tiptap [editor]="tiptapEditor"></div>
  </div>

  @if (hasError()) {
    <div class="input-error">
      <p>{{ maxItemsErrorMessage() }}</p>
    </div>
  }
</div>

<ng-template #suggestionMenu>
  @let suggestionsToShow = suggestions();
  @if (suggestionsToShow.length > 0) {
    @let scrollContainerHeight = suggestionsToShow.length * 68 + 32;
    @let overflowHeight = scrollContainerHeight < 350 ? scrollContainerHeight : 350;
    <div
      class="surface-elevated border-radius-200 vpad-200 hpad-100 absolute chip-list-menu scrollable"
      cdkVirtualScrollingElement
      [style.height.px]="overflowHeight"
    >
      <cdk-virtual-scroll-viewport
        class="fill-height fill-width"
        minBufferPx="200"
        maxBufferPx="400"
        [itemSize]="68"
      >
        <div
          *cdkVirtualFor="
            let suggestion of suggestionsToShow;
            trackBy: trackSuggestion;
            let $index = index
          "
          class="suggestion-item pad-200 hflex-200 flex-align-items-center border-radius-100"
          [attr.id]="'suggestion-' + $index"
          [class.focused]="$index === focusedSuggestionIndex()"
          (mousedown)="$event.preventDefault(); selectSuggestion(suggestion)"
        >
          @if (suggestion.svgIcon) {
            <div class="pad-075 border-radius-150 border-muted surface-muted">
              <mdw-icon
                class="suggestion-item-icon {{
                  suggestion.svgIconClass ?? 'color-preset-' + (suggestion.avatarColor ?? 0)
                }}"
                [icon]="suggestion.svgIcon"
              ></mdw-icon>
            </div>
          } @else if (suggestion.avatarUrl || suggestion.avatarColor) {
            <mdw-avatar
              size="large"
              [class.squircle]="suggestion.avatarShape === 'squircle'"
              [name]="suggestion.value"
              [color]="suggestion.avatarColor"
              [src]="suggestion.avatarUrl"
              [srcVersion]="1"
              [loadingUser]="false"
            ></mdw-avatar>
          }
          <div class="overflow-hidden">
            <div class="hflex-050 flex-align-items-center">
              <p
                mdwTooltipIfClipped
                matTooltip
                [tooltip]="suggestion.value"
                class="overflow-text-ellipses"
              >
                {{ suggestion.value }}
              </p>

              @if (suggestion.statusSvg) {
                <mdw-icon
                  class="small-icon"
                  [class.icon-highlight]="suggestion.isConnectedUser"
                  [class.icon-info]="!suggestion.isConnectedUser && suggestion.isGuestUser"
                  [attr.data-pw]="
                    suggestion.isConnectedUser ? 'connected-user-icon' : 'guest-user-icon'
                  "
                  [matTooltip]="suggestion.isConnectedUser ? 'Connected User' : 'Guest User'"
                  [icon]="suggestion.statusSvg"
                ></mdw-icon>
              }
              @if (suggestion.isApp) {
                <span class="mdw-badge mdw-app-badge" data-pw="app-badge">APP</span>
              }
            </div>

            @if (suggestion.secondaryValue && suggestion.secondaryValue !== suggestion.value) {
              <p
                mdwTooltipIfClipped
                matTooltip
                [tooltip]="suggestion.secondaryValue"
                class="extra-small secondary bold overflow-text-ellipses"
              >
                {{ suggestion.secondaryValue }}
              </p>
            }
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  }
</ng-template>
